module.exports = __webpack_public_path__ + "img/vnpt_qrcode_ios_bachnghe.e0d9b351.png";